import EastIcon from "@mui/icons-material/East"
import { useRouter } from "next/router"
import { useMemo } from "react"

import { ButtonProps } from "src/components/common/button"
import { Dialog } from "src/components/common/dialog"
import { create } from "src/helpers/bem"
import { getPage } from "src/helpers/pages"
import { Dialogs, mergeDialog, useDialog } from "src/states/dialogs"
import { useLocale } from "src/states/locale"
import { TranslationMessages } from "src/translations"

import { PagesProps } from "src/types/SharedPageProps"

import styles from "./ShopCartOverviewRedirectDialog.module.scss"

const bem = create(styles, "ShopCartOverviewRedirectDialog")

type ShopCartOverviewRedirectDialogProps = {
  pages: PagesProps
  messages: TranslationMessages
}

export const ShopCartOverviewRedirectDialog = ({
  pages,
  messages,
}: ShopCartOverviewRedirectDialogProps) => {
  const locale = useLocale()
  const router = useRouter()
  const { open } = useDialog(
    "shopOrderOverviewRedirectDialog",
  ) as Dialogs["shopOrderOverviewRedirectDialog"]

  const webshopOrdersPage = useMemo(
    () => getPage("Webshop Incidents Template", locale, pages),
    [pages, locale],
  )

  const m = messages.pages.shop.cart.checkout.summary.redirectDialog
  const firstRowButtons: ButtonProps[] = [
    {
      title: m.button,
      variant: "contained",
      endIcon: <EastIcon fontSize="small" />,
      onClick: async () => {
        await router.push(webshopOrdersPage?.uri as string)
        mergeDialog("shopOrderOverviewRedirectDialog", {
          open: false,
        })
      },
    },
  ]

  return (
    <Dialog firstRowButtons={firstRowButtons} open={open} title={m.title}>
      <div className={bem()}>{m.content}</div>
    </Dialog>
  )
}

export default ShopCartOverviewRedirectDialog
